var PaymentFlow = /* @__PURE__ */ ((PaymentFlow2) => {
  PaymentFlow2["REDIRECT"] = "Redirect";
  PaymentFlow2["ACTIONLESS"] = "Actionless";
  PaymentFlow2["QR_CODE"] = "QrCode";
  PaymentFlow2["UNDEFINED"] = "Undefined";
  return PaymentFlow2;
})(PaymentFlow || {});
var PaymentResult = /* @__PURE__ */ ((PaymentResult2) => {
  PaymentResult2["Success"] = "success";
  PaymentResult2["Approved"] = "approved";
  PaymentResult2["Pending"] = "pending";
  PaymentResult2["Failed"] = "failed";
  PaymentResult2["Redirect"] = "redirect";
  PaymentResult2["Error"] = "error";
  PaymentResult2["Cancelled"] = "cancelled";
  PaymentResult2["Refused"] = "refused";
  PaymentResult2["InternalError"] = "internal-error";
  PaymentResult2["Received"] = "received";
  return PaymentResult2;
})(PaymentResult || {});
export {
  PaymentFlow,
  PaymentResult
};
//# sourceMappingURL=types.js.map
